import type { AxiosRequestConfig } from 'axios'

const BUG_REPORT_BOT_PROTECTION_ENABLED =
  import.meta.env.VITE_APP_BUG_REPORT_BOT_PROTECTION_ENABLED === 'true'

const integrationUrl = normalizeWafEnvironmentValue(
  import.meta.env.VITE_APP_AWS_WAF_INTEGRATION_URL
)
const apiKey = normalizeWafEnvironmentValue(import.meta.env.VITE_APP_AWS_WAF_CAPTCHA_API_KEY)

export const getWafRequestConfig = (wafToken?: string): AxiosRequestConfig =>
  wafToken
    ? {
        headers: {
          'x-aws-waf-token': wafToken
        }
      }
    : {}

export const getWafCaptchaConfiguration = () => ({
  enabled: BUG_REPORT_BOT_PROTECTION_ENABLED,
  integrationUrl,
  apiKey
})

export const getWafCaptchaScriptUrl = (): string | undefined => {
  if (!integrationUrl) {
    return undefined
  }

  return `${integrationUrl.replace(/\/$/, '')}/jsapi.js`
}

function normalizeWafEnvironmentValue(value: string | undefined): string | undefined {
  if (!value) {
    return undefined
  }

  const trimmedValue = value.trim()
  const quote = trimmedValue[0]
  const hasMatchingQuotes = (quote === '"' || quote === "'") && trimmedValue.at(-1) === quote

  return hasMatchingQuotes ? trimmedValue.slice(1, -1) : trimmedValue
}
